import { render, staticRenderFns } from "./TributePanelSuper.vue?vue&type=template&id=6683b3e7&scoped=true"
import script from "./TributePanelSuper.vue?vue&type=script&lang=js"
export * from "./TributePanelSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683b3e7",
  null
  
)

export default component.exports